import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { GridModule } from '@progress/kendo-angular-grid';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { SharedModule } from '../../shared/shared.module';
import { PartCategoryAddDialogComponent } from './components/part-category-add-dialog/part-category-add-dialog.component';
import { PartCategoryListComponent } from './components/part-category-list/part-category-list.component';
import { PartCategoryRoutingModule } from './part-category-routing.module';
import { PartCategoryService } from './service/part-category.service';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    PartCategoryRoutingModule,
    GridModule,
    InputsModule
  ],
  declarations: [PartCategoryListComponent, PartCategoryAddDialogComponent],
  exports: [],
  providers: [PartCategoryService],
  entryComponents: [PartCategoryAddDialogComponent]
})
export class PartCategoryModule {}
